module.exports = __webpack_public_path__ + "img/CHINA_INSURANCE.09f44823.jpg";